(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  if (L.Edit == null) {
    L.Edit = {};
  }

  L.Edit.PolyWithHoles = (function(superClass) {
    extend(PolyWithHoles, superClass);

    function PolyWithHoles() {
      this._updateTooltip = bind(this._updateTooltip, this);
      this._fireEdit = bind(this._fireEdit, this);
      this._onMouseMove = bind(this._onMouseMove, this);
      this._setTooltipError = bind(this._setTooltipError, this);
      this._setTooltipHelp = bind(this._setTooltipHelp, this);
      return PolyWithHoles.__super__.constructor.apply(this, arguments);
    }

    PolyWithHoles.prototype.initialize = function(poly, options) {
      var base, base1;
      this._poly = poly;
      this._poly.isValid = true;
      L.setOptions(this, options);
      if ((base = this.options).successColor == null) {
        base.successColor = (options != null ? options.color : void 0) != null ? options.color : '#00ff00';
      }
      if ((base1 = this.options).errorColor == null) {
        base1.errorColor = '#ff0000';
      }
      this._handlers = [];
      return L.Edit.PolyWithHoles.include(L.Mixin.Events);
    };

    PolyWithHoles.prototype.clearMarkers = function() {
      var j, l, len, ref, ref1, results;
      ref = this._handlers;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        l = ref[j];
        results.push(l != null ? (ref1 = l._markerGroup) != null ? ref1.eachLayer((function(_this) {
          return function(l) {
            return App.map.removeLayer(l);
          };
        })(this)) : void 0 : void 0);
      }
      return results;
    };

    PolyWithHoles.prototype.addHooks = function() {
      var i, j, l, len, ref, ref1, ref2, ref3, ref4, ref5, v;
      l = new L.Edit.BetterPoly(this._poly, {
        latlngs: this._poly._latlngs
      });
      if (typeof l.enable === "function") {
        l.enable();
      }
      this._handlers.push(l);
      if (((ref = this._poly) != null ? ref._holes : void 0) != null) {
        ref2 = (ref1 = this._poly) != null ? ref1._holes : void 0;
        for (i = j = 0, len = ref2.length; j < len; i = ++j) {
          v = ref2[i];
          l = new L.Edit.BetterPoly(this._poly, {
            latlngs: v
          });
          if (typeof l.enable === "function") {
            l.enable();
          }
          this._handlers.push(l);
        }
      }
      this._poly.on('edit', this._fireEdit);
      this._tooltip = new L.Tooltip(this._poly._map);
      if (((ref3 = this._poly) != null ? ref3._map : void 0) != null) {
        L.DomUtil.disableTextSelection();
        if (typeof this._setTooltipHelp === "function") {
          this._setTooltipHelp();
        }
        if ((ref4 = this._poly) != null) {
          ref4._map.on('mousemove', this._onMouseMove);
        }
        return (ref5 = this._poly) != null ? ref5._map.fire('mousemove') : void 0;
      }
    };

    PolyWithHoles.prototype._setTooltipHelp = function() {
      if (this._tooltip._container == null) {
        return;
      }
      this._tooltip.removeError().updateContent({
        text: 'Click and drag a point to move it. <br /> Single click a point to delete it. <br /> Click and drag a ghost point to add a new point <br />'
      });
      return this._poly.setStyle({
        color: this.options.successColor
      });
    };

    PolyWithHoles.prototype._setTooltipError = function() {
      this._tooltip.showAsError().updateContent({
        text: 'Areas may not intersect themselves'
      });
      return this._poly.setStyle({
        color: this.options.errorColor
      });
    };

    PolyWithHoles.prototype._onMouseMove = function(e) {
      return this._updateTooltip(e.latlng);
    };

    PolyWithHoles.prototype._fireEdit = function(e) {
      var p;
      p = L.GeoUtil.readToJSTS(this._poly);
      if (p.geometry != null) {
        p = p.geometry;
      }
      if (!p.isValid()) {
        this._setTooltipError();
        this.fire('geometry-invalid');
        return this._poly.isValid = false;
      } else {
        this._setTooltipHelp();
        this.fire('geometry-valid', {
          layer: this._poly
        });
        return this._poly.isValid = true;
      }
    };

    PolyWithHoles.prototype._updateTooltip = function(latlng) {
      if (latlng) {
        return this._tooltip.updatePosition(latlng);
      }
    };

    PolyWithHoles.prototype.removeHooks = function(cb) {
      var i, j, len, ref, ref1, ref2, ref3, ref4;
      if (cb == null) {
        cb = false;
      }
      ref = this._handlers;
      for (j = 0, len = ref.length; j < len; j++) {
        i = ref[j];
        if (i != null) {
          if (typeof i.disable === "function") {
            i.disable();
          }
        }
      }
      if ((ref1 = this._tooltip) != null) {
        if (typeof ref1.dispose === "function") {
          ref1.dispose();
        }
      }
      if ((ref2 = this._poly) != null) {
        if ((ref3 = ref2._map) != null) {
          if (typeof ref3.off === "function") {
            ref3.off('mousemove', this._onMouseMove);
          }
        }
      }
      if ((ref4 = this._poly) != null) {
        if (typeof ref4.off === "function") {
          ref4.off('edit');
        }
      }
      this.clearAllEventListeners();
      if (cb !== false) {
        return cb();
      }
    };

    return PolyWithHoles;

  })(L.Handler);

}).call(this);
